import { useEffect, useState } from 'react'
import { fetchWithAuth, BASE_BACKEND_URL } from '../../auth'
export function useQuoteViewData(quoteId) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [quote, setQuote] = useState(null)

  useEffect(() => {
    if (!quoteId) return

    const abortController = new AbortController()

    const fetchQuote = async () => {
      try {
        setLoading(true)
        setError(null)

        const quoteData = await fetchWithAuth(`${BASE_BACKEND_URL}/quotes/${quoteId}`, {
          signal: abortController.signal
        })

        setQuote(quoteData)
      } catch (e) {
        if (e.name !== 'AbortError') {
          console.error(e)
          setError(e.message === 'HTTP error 404' ? 'No se encontró la cotización' : 'Error cargando datos')
        }
      } finally {
        setLoading(false)
      }
    }

    fetchQuote()
    return () => abortController.abort()
  }, [quoteId])

  return { loading, error, quote }
}
